<template>
    <div :style="'height:' + height + ';width:' + width">
        <div class="menu-signature" v-show="!readOnly">
            <span @click="clear" class="btn btn-primary  btn-sm" title="Clear">
                Clear
            </span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span @click="undo" class="btn btn-warning btn-sm" title="Undo">
                Undo
            </span>
            <!--            <span @click="save" class="btn btn-success  btn-sm" title="Save">
                            Save
                        </span>-->
        </div>
        <div class="signature" :style="'height:' + height + ';width:' + width">
            <vue-signature :h="height" :w="width" :ref="name" :sigOption="option" :clearOnResize="true"
                           :disabled="readOnly"></vue-signature>
            <input type="hidden" :name="name" v-model="image">
            <input type="hidden" :name="name+'_structure'" v-model="structure">
        </div>
    </div>
</template>

<script>
import vueSignature from "vue-signature"

export default {
    name: "MSignature",
    props: {
        name: {
            type: String,
            default: null
        },
        value: {
            type: String,
            default: null
        },
        height: {
            type: String,
            default: '200px'
        },
        width: {
            type: String,
            default: '800px'
        },
        readOnly: {
            type: Boolean,
            default: false,
            required: false
        },
    },
    components: {
        vueSignature
    },
    data() {
        return {
            option: {
                penColor: "rgb(0, 0, 0)",
                backgroundColor: "rgb(255,255,255)"
            },
            image: null,
            structure: null
        }
    },
    methods: {
        clear() {
            var _this = this;
            _this.$refs[this.name].clear();
            this.initialImage = null;
        },
        undo() {
            var _this = this;
            var sig =  _this.$refs[this.name].sig;
            var data = sig.toData();
            if (data) {
                data.pop()
                sig.fromData(data);
            }
           
        },
        save() {
            var _this = this;
            var png = _this.$refs[this.name].save()
            var sig =  _this.$refs[this.name].sig;
            this.structure = JSON.stringify(sig.toData());
            this.image = png;
        },
    },
    mounted() {
        if (this.value) {
            var _this = this;
            setTimeout(function () {
              /*  _this.$refs[_this.name].fromDataURL(_this.value);
                _this.image = _this.value;
                _this.initialImage = _this.value;*/
                const unescaped = _this.value;
                const parsed = JSON.parse(unescaped);
                _this.$refs[_this.name].sig.fromData(parsed);
            }, 2000)
        }
    }
}
</script>

<style scoped>
.signature div:first-child {
    border: 1px solid;
    padding: 0 !important;
}

.menu-signature {

    /*float: right;*/
    /*transform: translateY(-35px);*/
}
</style>
